import { merge } from 'lodash';

export default {
  config: state => merge({}, state.config, state.cmsConfig),
  platform: state => state.platform,
  product: state => state.product,
  translation: state => key => state.translations[key],
  translations: state => state.translations,
  language: state => state.language,
  game: state => state.game,
  ui: state => state.ui,
  isLogoEnabled(state) {
    return state.config.logo.enabled
      && state.product.deliveryPlatform === 'retail'
      && state.product.deliveryPlatform === 'terminal';
  },
  raceId: state => state.game.raceId,
  currentStage: state => state.game.currentStage,
  countdownTime: state => state.game.countdownTime,
  lastCountdownTime: state => state.config.lastCountdownTime,
  gameOffer: state => state.game.offer,
  results: state => state.game.results,
  winnerResult: state => state.game.winner,
  previousResults: state => state.game.previousResults,
  knockoutResults: state => state.game.knockout,
  videoId: state => state.game.videoId,
  tournamentId: state => state.game.tournamentId,
  raceStartTime: state => state.game.raceStartTime,
  betsConfig: state => state.config.game.bets,
  betsMap: state => state.config.game.betsMap,
  isLoaderActive: state => state.ui.isLoaderActive,
  isLastCountdown: state => false,
  // isLastCountdown(state) {
  //   return state.game.currentStage === 'countdown'
  //     && state.game.countdownTime <= state.config.lastCountdownTime;
  // },
  isStreamRunner: state => state.appMode === 'stream-runner',
  isStreamPlayer: state => state.appMode === 'stream-player',
  streamConfig: state => state.config.stream,
  bgVideo: state => state.ui.bgVideo,
  appMode: state => state.appMode,
  isStateMode: state => state.game.stateMode,
  infoMessage: state => state.ui.infoMessage,
};
